module.exports = __webpack_public_path__ + "static/img/port (1).7cbbdb98.png";